<template>
	<!-- <router-view v-slot="{ Component }">
		<keep-alive>
			<component :is="Component"></component>
		</keep-alive>
	</router-view> -->
	<router-view></router-view>

	<!-- <info-form></info-form> -->

	<!-- <van-tabbar route placeholder v-if="isTabbarPage">
		<van-tabbar-item replace to="/" icon="home-o">工作台</van-tabbar-item>
		<van-tabbar-item replace to="/orders" icon="orders-o"
			>展业记录</van-tabbar-item
		>
		<van-tabbar-item replace to="/center" icon="smile-o">我的</van-tabbar-item>
	</van-tabbar> -->
</template>
<script setup>
import { watch } from 'vue'
import { useRoute } from 'vue-router'
import infoForm from './infoForm.vue'
import { computed } from 'vue'
// import { useStore } from 'vuex'
const route = useRoute()
// const store = useStore()
// store.dispatch('readSecond')

watch(
	() => route.meta?.title,
	(title) => {
		// var merge = '驾乘' || `驾乘${title ? `-${title}` : ''}`
		// document.title = merge
	}
)
const isTabbarPage = computed(() => route.meta.tabbar)
</script>

<style lang="scss">
.page {
	min-height: 100vh;
	padding: 0 $space_4 $space_4;
}
.tabbar-holder {
	height: 200px;
}
.tkon-toast .van-toast__text {
	font-size: $font_large;
}
</style>
